import api from "../utils/api"; // Your configured Axios instance

export const getFinancialDetailsById = async (companyId, version) => {
  try {
    const res = await api.get(
      `/api/company/financial-ability?companyId=${companyId}&version=${version}`
    );
    return res.data;
  } catch (error) {
    console.error("Failed to fetch details:", error);
    throw error;
  }
};

export const saveFinancialDetails = async (payload) => {
  try {
    const response = await api.post(`/api/company/financial-ability`, payload);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to save details");
  }
};

export const updateFinancialDetails = async (payload) => {
  try {
    const response = await api.put(`/api/company/financial-ability`, payload);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to save details");
  }
};
